import { useState } from "react"
import { Container } from "reactstrap"
import All from "./All/All"
import Active from "./Active/Active"
import Deactivated from "./Deactivated/Deactivated"
import Ended from "./Ended/Ended"

const Management = () => {

  const tabs = ['All', 'Active', 'Deactivated', 'Ended']
  const [activeTab, setActiveTab] = useState(tabs[0])
  return (

    <div style={{ background: "#f2f2f2", minHeight: "100dvh", paddingBlock: "1rem" }}>
      <Container fluid>
        <h4 className="fw-semibold mb-3">Advertisement Campaign Management</h4>

        <div className="bg-white p-2">
          <div className="d-flex my-3 gap-3">
            {tabs.map((tab, index) => (
              <div
                key={index}
                className="fw-medium"
                style={{
                  color: tab === activeTab ? "#EC7426" : 'black',
                  cursor: "pointer",
                  transition: "color 0.3s ease",
                  fontSize: "1.25rem",
                  padding: '.5rem 0rem'
                }}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </div>
            ))}
          </div>


            {activeTab === "All" && <All />}
            {activeTab === "Active" && <Active />}
            {activeTab === "Deactivated" && <Deactivated />}
            {activeTab === "Ended" && <Ended />}


        </div>
      </Container>
    </div>

  )
}

export default Management